import { GET_PRODUCTS } from '../constants/product';
import { SHOW_LOADING, HIDE_LOADING } from '../constants/commons';


export const getProducts = (products) => {
    return {
        type: GET_PRODUCTS,
        payload: products
    }
}



export const showLoading = () => {
    return {
        type: SHOW_LOADING
    }
}

export const hideLoading = () => {
    return {
        type: HIDE_LOADING
    }
}